import { createSlice } from '@reduxjs/toolkit';

// The Care Packages draft queue. Same model as the domiciliary-schedule draft
// (assign/unassign, stop visit) but kept separate so package planning and the
// daily schedule don't share one queue. The board renders the server snapshot
// with this queue applied on top (see applyPackagesDraft); Publish replays the
// queue against the API.
//
// A change looks like: { id, type, payload, label, dedupKey? }
//   type ∈ assign | stopVisit
const initialState = { changes: [] };

const domiciliaryPackagesDraftSlice = createSlice({
  name: 'domiciliaryPackagesDraft',
  initialState,
  reducers: {
    enqueueChange(state, action) {
      const change = action.payload;
      if (change.dedupKey) {
        const idx = state.changes.findIndex((c) => c.dedupKey === change.dedupKey);
        if (idx >= 0) { state.changes[idx] = change; return; }
      }
      state.changes.push(change);
    },
    removeChange(state, action) {
      state.changes = state.changes.filter((c) => c.id !== action.payload);
    },
    setChanges(state, action) {
      state.changes = action.payload;
    },
    clearChanges(state) {
      state.changes = [];
    },
  },
});

export const { enqueueChange, removeChange, setChanges, clearChanges } = domiciliaryPackagesDraftSlice.actions;
export default domiciliaryPackagesDraftSlice.reducer;
